import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { Card } from '../../../card-container/card/card';
import { Student360Service } from '../../../../student360.service';
import { UserService } from '../../../../../shared-components/user/user.service';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { StudentService } from '../../../../../shared-components/student/student.service';
import { StudentSummaryService } from '../../../student-summary.service';
import { YearService } from '../../../../../shared-components/year/year.service';
import { LoginService } from '../../../../../shared-modules/login/login.service';
import { CardAttendanceHistory } from './card-attendance-history';
import { MatDialog } from '@angular/material/dialog';
import { AttendanceDetailsModalComponent } from './attendance-details-modal/attendance-details-modal.component';
@Component({
    selector: 'app-attendance-history-card',
    templateUrl: './attendance-history-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./attendance-history-card.component.css']
})
export class AttendanceHistoryCardComponent implements OnInit, OnDestroy {

    @Input() data: any;
    subscriptions: Subscription[] = [];
    card: Card;
    // Angular Material Table
    displayedColumns: string[] = ['meets', 'courseSection', 'name', 'dropped', 'pr', 'td', 'ab', 'ex', 'un'];
    attendanceRecords: CardAttendanceHistory[] = [];
    recordsToDisplay: CardAttendanceHistory[] = [];
    showDropped = true;

    constructor(
        private student360Service: Student360Service,
        private userService: UserService,
        private cdr: ChangeDetectorRef,
        private router: Router,
        private studentService: StudentService,
        private studentSummaryService: StudentSummaryService,
        private yearService: YearService,
        private loginService: LoginService,
        private dialog: MatDialog
    ) { }

    ngOnInit() {
        this.card = this.data;
        this.displayedColumns = ['meets', 'Term', 'courseSection', 'name', 'dropped', 'td', 'ab'];
        if (this.card.display != 'Off') {
            const schoolIdStream = interval(100).subscribe(x => {
                if (this.studentService.studentEnrollment !== undefined) {
                    this.getStudentAttendanceHistory();
                    schoolIdStream.unsubscribe();
                }
            });
        }
    }

    ngOnDestroy(): void {
    }

    getStudentAttendanceHistory() {
        const schoolId = this.studentService.studentEnrollment != null ? this.studentService.studentEnrollment.SchoolId : 0;
        this.studentSummaryService.getCardStudentAttendance(this.studentService.selectedStudent.Id, schoolId, this.yearService.student360Year.AYIdentifier, this.yearService.student360Year.Id).subscribe((response) => {
            if (response.ok) {
                this.attendanceRecords = response.body;
                this.hideShowDropped();
            }
        });
    }

    goToAttendance() {
        this.router.navigateByUrl('/student360/attendance?studentPortal=true');
    }

    hideShowDropped() {
        if (!this.showDropped) {
            this.recordsToDisplay = this.attendanceRecords.filter(ar => ar.IsDropped == false);
        } else {
            this.recordsToDisplay = _.cloneDeep(this.attendanceRecords);
        }
        this.recordsToDisplay.sort((a, b) => (a.ClassMeets > b.ClassMeets) ? 1 : -1);
        this.updateView();
    }

    attendanceRecordClick(sectionId: number, type: string) {
        this.studentSummaryService.getAttendanceHistoryDetail(this.studentService.selectedStudent.Id, sectionId, type).subscribe((response) => {
            if (response.ok) {
                this.dialog.open(AttendanceDetailsModalComponent, { autoFocus: false, minWidth: '30vw', maxHeight: '45vh', disableClose: true, data: { attendanceDetails: response.body } });
            }
        });
    }

    updateView() {
        this.cdr.detectChanges();
    }

}
